import type { UntitledIconData } from '../../UntitledIconData'

export const ulXCircle: UntitledIconData = {
  prefix: 'ul',
  name: 'x-circle',
  paths: [
    {
      shape:
        'M15 9L9 15M9 9L15 15M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z',
    },
  ],
}
